import { Tag } from '@/components';
import { DateTime } from '@/types/common';
import { formatMonthDate, isNonNil } from '@vuddy/utils';

interface SaleStartAtTagProps {
  startAt?: DateTime;
}

export const SaleStartAtTag = ({ startAt }: SaleStartAtTagProps) => {
  return (
    <Tag
      label={`오픈 ${isNonNil(startAt) ? formatMonthDate(startAt) : 'MM/dd HH:mm'}`}
      variant="lightred"
      size="small"
      iconName="OUTLINE_TIMER"
    />
  );
};
